import { isNonNil } from '@shady-pines/types';
import { useEffect } from 'react';
import { useUserStore } from '../user/user-store';
import { useGlobalContextStore } from './global-context-store';

export const useManageGlobalContext = () => {
  const fetchConfigurations = useGlobalContextStore((s) => s.fetchConfigurations);
  const configurationsFetching = useGlobalContextStore((s) => s.loading.configurations);
  const configurationsFetched = useGlobalContextStore((s) => isNonNil(s.configurations));

  useEffect(() => {
    if (configurationsFetched || configurationsFetching) {
      return;
    }

    void fetchConfigurations();
  }, [configurationsFetched, configurationsFetching, fetchConfigurations]);

  const userId = useUserStore((s) => s.me);
  const fetchUserFeatures = useGlobalContextStore((s) => s.fetchUserFeatures);
  const userFeaturesFetching = useGlobalContextStore((s) => s.loading.userFeatures);
  const userFeaturesFetched = useGlobalContextStore((s) => isNonNil(s.userFeatures));

  useEffect(() => {
    if (userFeaturesFetched || userFeaturesFetching) {
      return;
    }

    void fetchUserFeatures(userId);
  }, [fetchUserFeatures, userFeaturesFetched, userFeaturesFetching, userId]);

  const fetchGlobalFeatures = useGlobalContextStore((s) => s.fetchGlobalFeatures);
  const globalFeaturesFetching = useGlobalContextStore((s) => s.loading.globalFeatures);
  const globalFeaturesFetched = useGlobalContextStore((s) => isNonNil(s.globalFeatures));

  useEffect(() => {
    if (globalFeaturesFetched || globalFeaturesFetching) {
      return;
    }

    void fetchGlobalFeatures();
  }, [fetchGlobalFeatures, globalFeaturesFetched, globalFeaturesFetching]);

  const initialLoading = useGlobalContextStore((s) => s.loading.initial);
  const setInitialLoadCompleted = useGlobalContextStore((s) => s.setInitialLoadCompleted);
  useEffect(() => {
    if (!initialLoading) {
      return;
    }

    if (globalFeaturesFetched && configurationsFetched && userFeaturesFetched) {
      setInitialLoadCompleted();
    }
  }, [
    configurationsFetched,
    globalFeaturesFetched,
    initialLoading,
    setInitialLoadCompleted,
    userFeaturesFetched,
  ]);
};
